import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { B50, B75, B200, B400, N20A, N30, N500 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryPill = styled.button<{
	isSelected?: boolean;
	isDisabled?: boolean;
}>({
	outline: 'none',
	boxSizing: 'border-box',
	padding: `3px ${token('space.075', '6px')} ${token(
		'space.050',
		'4px',
	)} ${token('space.075', '6px')}`,
	transition: '0.2s ease',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: ({ isDisabled, isSelected }) =>
		isDisabled || !isSelected
			? token('color.background.neutral', N20A)
			: token('color.background.selected', B50),
	display: 'inline-flex',
	borderWidth: '1px',
	borderStyle: 'solid',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	borderColor: ({ isDisabled, isSelected }) =>
		isDisabled || !isSelected ? 'transparent' : token('color.text.selected', B400),
	borderRadius: '13px',
	fontSize: '13px',
	lineHeight: '18px',
	height: '26px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ isDisabled, isSelected }) =>
		isDisabled || !isSelected ? token('color.text', N500) : token('color.text.selected', B400),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	cursor: ({ isDisabled }) => (isDisabled ? 'inherit' : 'pointer'),
	marginTop: 0,
	marginBottom: token('space.100', '8px'),
	marginRight: token('space.050', '4px'),
	userSelect: 'none',
	maxWidth: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	verticalAlign: 'top',

	'&:focus': {
		boxShadow: `0 0 0 2px ${token('color.border.selected', B200)}`,
	},
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		backgroundColor: ({ isDisabled, isSelected }) => {
			if (isDisabled) {
				return token('color.background.neutral', N20A);
			}
			if (isSelected) {
				return token('color.background.selected.hovered', B75);
			}
			return token('color.background.neutral.hovered', N30);
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EllipsisPill = styled(CategoryPill)({
	paddingLeft: '4px',
	paddingRight: '4px',
	verticalAlign: 'top',
	marginRight: 0,
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PlaceholderPill = styled(CategoryPill)<{ width: number }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: `${({ width }) => width}px`,
	flexShrink: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TextWrapper = styled.div({
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	flexShrink: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryNameWrapper = styled.div({
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TrophyIconWrapper = styled.div({
	margin: `1px ${token('space.075', '6px')} 1px 0px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FireIconWrapper = styled.div({
	margin: `0px ${token('space.075', '6px')} 1px 0px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StarIconWrapper = styled.div({
	margin: `1px ${token('space.075', '6px')} 0px 0px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconWrapper = styled.div({
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Bold = styled.span({
	fontWeight: 600,
	flexShrink: 0,
	marginLeft: token('space.075', '6px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoCountSpace = styled.span({
	marginLeft: token('space.025', '2px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineDialogContentWrapper = styled.div({
	maxWidth: '260px',
	padding: token('space.200', '16px'),
	boxSizing: 'border-box',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoryList = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		paddingLeft: 0,
	},
});

export const COLLAPSED_INLINE_WRAPPER_HEIGHT = 26;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineCategorySelectorWrapper = styled.div<{
	isCollapsed?: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: ({ isCollapsed }) => (isCollapsed ? `${COLLAPSED_INLINE_WRAPPER_HEIGHT}px` : 'auto'),
	padding: `${token('space.025', '2px')} ${token('space.025', '2px')} ${token('space.050', '4px')}`,
	overflow: 'hidden',
	position: 'relative',
	display: 'flex',
	alignItems: 'flex-start',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineExpandCollapsePill = styled(CategoryPill)<{
	isSelected?: boolean;
}>({
	display: 'inline-flex',
	alignItems: 'center',
	height: '24px',
	padding: 0,
	margin: '1px 0',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PlaceholderExpandPill = styled(PlaceholderPill)({
	height: '24px',
	margin: '1px 0',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InlineCategoryList = styled(CategoryList)({
	maxWidth: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> .hidden': {
		display: 'none',
	},
});
